import { createAction, props } from '@ngrx/store';
import { OracleStorageActionModel } from '@models/common/oracle-storage-action.model';
import { CustomerModel } from '@models/configuration/customer.model';

export const createCustomer = createAction(
    '[Customer] Create Customer',
    props<{ action: OracleStorageActionModel<CustomerModel> }>()
);

export const createCustomerSuccess = createAction(
    '[Customer] Create Customer Success',
    props<{ Customer: CustomerModel }>()
);

export const searchCustomersAuthorization = createAction(
    '[Customers] Search CustomersAuthorization',
    props<{ action: OracleStorageActionModel<CustomerModel> }>()
);

export const searchCustomers = createAction(
    '[Customers] Search Customers',
    props<{ action: OracleStorageActionModel<CustomerModel> }>()
);

export const searchCustomersSuccess = createAction(
    '[Customers] Search Customers Success',
    props<{ Customers: CustomerModel[] }>()
);

export const searchCustomersAuthorizationSuccess = createAction(
    '[Customers] Search CustomersAuthorization Success',
    props<{ CustomersAuthorization: CustomerModel[] }>()
);

export const updateCustomer = createAction(
    '[Customer] Update Customer',
    props<{ action: OracleStorageActionModel<CustomerModel> }>()
);

export const updateCustomerSuccess = createAction(
    '[Customer] Update Customer Success',
    props<{ Customer: CustomerModel }>()
);

export const selectCustomer = createAction(
    '[Customer] Select Customer',
    props<{ Customer: CustomerModel }>()
);

export const setCurrentCustomer = createAction(
    '[Customer] Current Customer',
    props<{ rowKey: string | null }>()
);

export const deleteCustomer = createAction(
    '[Customer] Delete Customer',
    props<{ action: OracleStorageActionModel<CustomerModel> }>()
);

export const deleteCustomerSuccess = createAction(
    '[Customer] Delete Customer Success',
    props<{ Customer: CustomerModel }>()
);

export const cleanCustomers = createAction(
    '[Customers] Clean Customers',
    props<{ Customers: any[] }>()
);

export const resetLoading = createAction(
    '[Loading] Reset Loading Success'
);